var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColoredRipple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 79,
    viewBox: "0 0 70 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FFDCE3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7465F",
    d: "M27.202 67.883c-.518 0-.933-.155-1.244-.466-.311-.311-.466-.726-.466-1.244V62.44c0-2.125.362-4.042 1.088-5.752.725-1.71 1.606-3.2 2.643-4.47 1.037-1.27 2.41-2.786 4.12-4.548 2.125-2.229 3.667-4.056 4.626-5.48.959-1.426 1.438-3.046 1.438-4.86 0-2.746-1.166-4.936-3.498-6.569-2.333-1.632-5.028-2.448-8.085-2.448-3.265 0-5.986.855-8.163 2.565-2.177 1.71-3.576 4.457-4.198 8.24-.207 1.14-.83 1.71-1.866 1.71h-1.244c-.466 0-.855-.142-1.166-.427-.31-.285-.466-.66-.466-1.127.052-2.85.83-5.455 2.332-7.813 1.503-2.358 3.537-4.224 6.103-5.597 2.565-1.374 5.454-2.06 8.668-2.06 3.472 0 6.44.622 8.9 1.865 2.463 1.244 4.303 2.903 5.52 4.976a12.975 12.975 0 0 1 1.827 6.685c0 2.695-.622 5.028-1.865 6.997-1.244 1.97-3.084 4.224-5.52 6.763-2.177 2.28-3.796 4.224-4.859 5.83-1.062 1.607-1.593 3.447-1.593 5.52v3.732c0 .518-.156.933-.467 1.244-.31.31-.725.466-1.244.466h-1.321zM26.269 79c-.518 0-.933-.155-1.244-.466-.31-.311-.466-.726-.466-1.244v-2.954c0-.519.155-.946.466-1.283.311-.337.726-.505 1.244-.505h2.954c.518 0 .946.168 1.283.505.337.337.505.764.505 1.283v2.954c0 .518-.168.933-.505 1.244-.337.31-.765.466-1.283.466h-2.954z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredRipple);
export default __webpack_public_path__ + "static/media/colored-ripple.6c35b2f9a9842930c1d96da7e9778cb7.svg";
export { ForwardRef as ReactComponent };